<template>
    <div ref="infoHover"  class="info-hover-box"  v-show="show"  >
        <div class="title">
          <span class="title-text">{{ vedioData.channelName }}</span>
        </div>
        <div class="right-content-delete" @click="closePop">
          <img class="icon" src="@/assets/image/index/删除.png"/>
        </div>
        <div class="vedio" v-if="vedioShow" >
          <vidobox  :showBottom="false" :imgUrl ='vedioData.imageUrl' :id= "'veds'+vedioData.channelId" :url="vedioData.liveUrl" :list="vedioData" 
          width="375" height="220"  :kheight="'40px'" :kbottom="'0px'" :token="vedioData.token" />
        </div>
    </div>
      
</template>
<script>
import {getVideoData} from '@/utils/indexApi'
import vidobox from '@/components/common/vidobox.vue';
export default{
  components:{vidobox},
  props:{
    model:{
      type:Object,
      default(){
        return {}
      }
    },
  },
  data(){
    return{
      show:false,
      vedioData:{},
      vedioShow:false
    }
  },
  methods:{
    openPop(pos,id){
   
      this.show =true
      this.$nextTick(()=>{
       
        this.$refs.infoHover.style.position='abusolute'
        this.$refs.infoHover.style.left=pos.left
        this.$refs.infoHover.style.top=pos.top
        
      })
     this.getData(id)
    },
    closePop(){
      this.show = false
      this.vedioShow = false
    },
    getData(id){
      getVideoData(id).then(res=>{
        this.vedioData = res.data
        this.vedioShow =true
      })
    },
    created(){
    }
  }
}
</script>
<style scoped lang="scss">
.info-hover-box{
  position: absolute;
  width: 408px;
  height: 298px;
  background:url('@/assets/image/index/视频背景框@2x.png');
  background-size: contain;
  padding: 16px;
  padding-top: 24px;
  z-index: 999;
  .vedio{
    width: 375px;
    height: 220px;
  }
}
.title {
  width: 236px;
  height: 26px;
  margin-bottom: 12px;
  background: url('@/assets/image/index/二级标题-背景@2x.png');
  background-size: contain;

  .title-text {
    margin-left: 32px;
    font-family: AlibabaPuHuiTi_2_75_SemiBold;
    font-size: 18px;
    color: #D1D6DF;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    // background: linear-gradient(270deg, #ACDDFF 0%, #FFFFFF 100%);
  }
}
.right-content-delete{
  position: absolute;
  top: 22px;
  right: 18px;
  .icon{
    width: 24px;
    height: 24px;
  }
}
  </style>